module.exports = __webpack_public_path__ + "img/cpzxBanner.4e0c4a6b.png";